const initSapInvoiceOldData = {
  
}

export function sapInvoiceOldData(
  state = initSapInvoiceOldData,
  action
) {
  switch (action.type) {
    case "SAP_INVOICE_OLD_FETCH_DATA_SUCCESS":
      return action.dataSapInvoiceOld;
    default:
      return state;
  }
}
